import {Injectable} from "@angular/core";
import {FormControl} from "@angular/forms";

@Injectable()
export class AgeRangeValidatorService {

    private errors:any={};

    public validateMinAgeRange(c: FormControl) {
        return !!c.value
    }

    public validate(posForm) {
        this.errors = {};
        let isValid = true;
        if(!this.validateForm(posForm)){
            isValid=false;
        };
        return {valid:isValid, errors:this.errors};
    }

    public validateChargeType(c: FormControl) {
        let error = {};
        let isValid = true;

        if(c.value.hasCharge){
            if(c.value.chargeType == undefined || c.value.chargeType == null){
                error['chargeType']='required';
                isValid=false;
            }
            return isValid?null:error;
        }else{
            return null;
        }
    }

    public validateTo(c: FormControl) {
        let error = {};
        let isValid = true;

        if(c.value.hasCharge){
            if(c.value.to == undefined || c.value.to == null){
                error['ageTo']='required';
                isValid=false;
            }
            return isValid?null:error;
        }else{
            return null;
        }
    }

    public validateAmountRange(c: FormControl) {
        let validPercentageFieldTwoDecimalsPattern = /^[0-9]{1,3}([,.][0-9]{1,2})?$/;
        let amountPattern = /^[0-9]{1,8}([,.][0-9]{1,2})?$/;
        let error = {};
        let isValid = true;

        if(c.value.hasCharge){
            if((c.value.hasCharge) && (c.value.chargeType == 'PERCENTAGE' && !validPercentageFieldTwoDecimalsPattern.test(c.value.value)) ||
                (c.value.chargeType == 'AMOUNT' && !amountPattern.test(c.value.value))) {
                error['amountAgeRange']='required';
                isValid=false;
            }
            if((c.value.hasCharge) &&
                (c.value.chargeType == 'PERCENTAGE' && c.value.value > 100 || c.value.value<=0) ||
                (c.value.hasCharge && !c.value.value) ||
                (c.value.chargeType == 'AMOUNT' && c.value.value <= 0)){
                error['amountAgeRange']='required';
                isValid=false;
            }
            return isValid?null:error;
        }else{
            return null;
        }
    }

    private validateForm(form) : boolean{
        if(form.valid){
            return true;
        } else {
            this.reportErrors(form);
            return false;
        }
    }

    private reportErrors(form: any) {
        Object.keys(form.controls).forEach((key) => {
            if(!!form.controls[key].errors){
                this.errors[key] = form.controls[key].errors;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/ageRange/age-range-validator.service.ts